import React, { useState } from 'react';
import { Card, Button } from './ui';
import { ShieldCheck, Plus, Minus, Scale, Clock, Lock, Zap, CreditCard } from 'lucide-react';
const CHECKOUT_URL = 'https://meal-preap.impultienda.ar/checkout';
export function Guarantee() {
  return <section className="py-10 px-4" data-id="element-181" data-mp="31lkejb9t5l4b">
      <div className="max-w-3xl mx-auto" data-id="element-182" data-mp="2wlg0drwdh2h9">
        <Card className="bg-brand-50 border-brand-200 text-center relative overflow-hidden" data-id="element-183" data-mp="2wmr1fjyfnw4o">
          <div className="absolute -right-10 -top-10 text-brand-200/60" data-id="element-184" data-mp="3u7lmsrowd2s9">
            <ShieldCheck className="w-64 h-64" data-id="element-185" data-mp="3pamvegwmb9xr" />
          </div>
          <div className="relative z-10" data-id="element-186" data-mp="3kibxtkpco08d">
            <ShieldCheck className="w-16 h-16 text-brand-500 mx-auto mb-6" data-id="element-187" data-mp="3khahb0pkelj9" />
            <h2 className="text-3xl font-bold text-ink mb-6" data-id="element-188" data-mp="3fkacet4gbotq">
              PROBALO DURANTE 7 DÍAS SIN RIESGO
            </h2>
            <p className="text-xl text-slate-300 mb-6" data-id="element-189" data-mp="gv343nfic1lc">
              Accedé a los 6 tomos y 5 bonos, revisá los contenidos y organizá
              tu primera semana de Meal Prep.
            </p>
            <p className="text-lg text-slate-400 mb-8" data-id="element-190" data-mp="2hjuykve6qcpp">
              Si sentís que no es para vos:
              <br data-id="element-191" data-mp="2lkeuxwqxpcas" />
              <strong className="text-ink" data-id="element-192" data-mp="2ln0y7k6sl5n7">
                podés solicitar la devolución
              </strong>
              <br data-id="element-193" data-mp="2csmnlux7ijaf" />
              dentro del período de garantía.
            </p>
            <p className="text-sm text-brand-600 font-medium" data-id="element-194" data-mp="2cqiacmdf47xh">
              Compra 100% protegida y sin vueltas.
            </p>
          </div>
        </Card>
      </div>
    </section>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Necesito saber cocinar para aplicar el Meal Prep?',
    a: 'No. Las recetas están explicadas paso a paso, con cantidades exactas y preparaciones simples pensadas para principiantes.'
  }, {
    q: '¿Cuánto tiempo me lleva preparar la semana?',
    a: 'Con el método Batch Cooking podés organizar tus comidas de la semana en pocas horas, en un solo día de cocina.'
  }, {
    q: '¿Necesito equipamiento especial o tuppers caros?',
    a: 'No. El Tomo 2 te muestra qué necesitás realmente y cómo organizarte con lo que ya tenés en tu cocina.'
  }, {
    q: '¿Sirve si entreno o busco un objetivo fitness?',
    a: 'Sí. Los recetarios están pensados para una alimentación fitness, con desayunos, snacks, almuerzos y cenas completos y porcionados.'
  }, {
    q: '¿Tengo que leer todos los tomos de una vez?',
    a: 'No. Podés empezar por el tomo o bono que necesites según cómo estés organizando tu semana hoy.'
  }, {
    q: '¿Cómo recibo el Meal Prep Fitness Listo?',
    a: 'Después de completar el pago, recibís acceso digital inmediato a los 6 tomos y 5 bonos.'
  }, {
    q: '¿Puedo verlo desde el celular?',
    a: 'Sí. Podés acceder desde el celular, tablet o computadora.'
  }, {
    q: '¿Incluye material físico?',
    a: 'No. Todo el contenido es 100% digital en PDF.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. La compra incluye una garantía de 7 días. Si no estás satisfecho escribís a supportpuntodigital@gmail.com y gestionamos la devolución.'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="py-12 px-4 bg-lav-50 pt-[4px] pb-[4px]" data-id="element-195" data-mp="14k0ghqml9nst">
      <div className="max-w-3xl mx-auto" data-id="element-196" data-mp="19kfpy73r2b5i">
        <h2 className="text-2xl md:text-3xl font-bold text-ink text-center mb-8 flex items-center justify-center gap-3" data-id="element-197" data-mp="19lhcp8u4om32">
          <span className="text-brand-500" data-id="element-198" data-mp="1djnh4a7hupkt">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-199" data-mp="1iihxl5hzo21r">
          {faqs.map((faq, i) => <div key={i} className="border border-lav-100 rounded-xl bg-white overflow-hidden" data-id="element-200" data-mp="1ncm45nnce82b" data-mpi={i}>
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpen(open === i ? null : i)} data-id="element-201" data-mp="1sc8k44uk22et">
                <span className="font-bold text-ink pr-8" data-id="element-202" data-mp="2yzytaxx8oz4r">{faq.q}</span>
                {open === i ? <Minus className="w-5 h-5 text-brand-500 shrink-0" data-id="element-203" data-mp="2u141j6hao08i" /> : <Plus className="w-5 h-5 text-slate-500 shrink-0" data-id="element-204" data-mp="37s94ahfyl8n2" />}
              </button>
              {open === i && <div className="px-6 pb-4 text-slate-400" data-id="element-205" data-mp="33rqeesxmmcni">{faq.a}</div>}
            </div>)}
        </div>
      </div>
    </section>;
}
export function CostOfInaction() {
  return <section className="py-12 px-4" data-id="element-206" data-mp="2b3b9iz87lapw">
      <div className="max-w-4xl mx-auto" data-id="element-207" data-mp="2b4clr70yo397">
        <div className="text-center mb-8" data-id="element-208" data-mp="2p215gbjal4co">
          <h2 className="text-2xl md:text-3xl font-bold text-ink mb-4 flex items-center justify-center gap-3" data-id="element-209" data-mp="2ozofpc7alpp2">
            <Scale className="w-9 h-9 text-lav-500" data-id="element-210" data-mp="2k50zs1qcu3m3" /> ¿CUÁNTO TIEMPO MÁS VAS A
            SEGUIR EMPEZANDO LA DIETA TODOS LOS LUNES?
          </h2>
        </div>

        <div className="overflow-x-auto mb-10" data-id="element-211" data-mp="3vh1tzw5zmk98">
          <table className="w-full text-left border-collapse bg-white rounded-xl overflow-hidden border border-lav-100" data-id="element-212" data-mp="7thf6cijd0b3">
            <thead data-id="element-213" data-mp="bvbccativm6i">
              <tr className="border-b border-lav-100 bg-lav-50" data-id="element-214" data-mp="bvujqxljqs6a">
                <th className="p-4 text-slate-300 font-medium" data-id="element-215" data-mp="3u0xuoyy71yem">
                  Sin un sistema de Meal Prep
                </th>
                <th className="p-4 text-brand-600 font-bold" data-id="element-216" data-mp="2v64jzkf2lrt">Costo real</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-lav-100" data-id="element-217" data-mp="qkh81ot5iu9n">
              <tr data-id="element-218" data-mp="vjk3qin8ro4y">
                <td className="p-4 text-slate-400" data-id="element-219" data-mp="vi0nut5hzf3p">
                  Cocinar todos los días sobre la marcha.
                </td>
                <td className="p-4 text-ink font-medium" data-id="element-220" data-mp="gtw3lkqsqvit">
                  Horas perdidas cada semana en la cocina
                </td>
              </tr>
              <tr data-id="element-221" data-mp="19ijr7mz0pwzj">
                <td className="p-4 text-slate-400" data-id="element-222" data-mp="19i1n64646eh2">
                  Abrir la heladera sin nada listo.
                </td>
                <td className="p-4 text-ink font-medium" data-id="element-223" data-mp="1eauv10wvq2xd">
                  Terminar comiendo cualquier cosa cuando llegás cansado
                </td>
              </tr>
              <tr data-id="element-224" data-mp="1j7qqcmtbj39j">
                <td className="p-4 text-slate-400" data-id="element-225" data-mp="1j78kqzkrncoy">
                  Comprar comida afuera o pedir delivery.
                </td>
                <td className="p-4 text-ink font-medium" data-id="element-226" data-mp="1a5r9buiazz6l">
                  Gastar de más todos los meses sin darte cuenta
                </td>
              </tr>
              <tr data-id="element-227" data-mp="1588vpqtccvs9">
                <td className="p-4 text-slate-400" data-id="element-228" data-mp="158r23g9pwqdw">
                  No saber qué cocinar ni qué comprar.
                </td>
                <td className="p-4 text-ink font-medium" data-id="element-229" data-mp="vgl8y37qc2x4">
                  Improvisar cada día y desperdiciar comida
                </td>
              </tr>
              <tr data-id="element-230" data-mp="qjl39tesl26j">
                <td className="p-4 text-slate-400" data-id="element-231" data-mp="qfxawxl32lte">
                  Volver a empezar cada lunes.
                </td>
                <td className="p-4 text-ink font-medium" data-id="element-232" data-mp="hhbxfgugxwzh">
                  Nunca sostener el progreso que querés lograr
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-233" data-mp="2y30cegz2arag">
          <h3 className="text-2xl font-bold text-brand-600 mb-4" data-id="element-234" data-mp="2y5cuqv8qf3o1">
            LA DIFERENCIA NO ES LA MOTIVACIÓN. ES TENER UN SISTEMA.
            <br data-id="element-235" data-mp="374q4lp0rpu9a" />
            <span className="text-lg font-medium text-slate-300 block mt-3" data-id="element-236" data-mp="3735bm3u3qjdj">
              La diferencia entre quienes mantienen una alimentación saludable y
              quienes abandonan no es la motivación. Es tener un sistema.
            </span>
          </h3>
          <blockquote className="text-xl text-slate-300 italic border-l-4 border-brand-400 pl-6 py-2 text-left" data-id="element-237" data-mp="2jevuvgbqwlt9">
            "Cocinás una vez, comés bien toda la semana y dejás de improvisar
            cada día."
          </blockquote>
        </div>

        {/* Final CTA Block */}
        <Card glow className="bg-white border-brand-200 text-center" data-id="element-238" data-mp="1qo3zgl2i816z">
          <div className="inline-flex items-center gap-2 bg-brand-100 text-brand-700 border border-brand-200 px-4 py-2 rounded-full font-bold mb-8" data-id="element-239" data-mp="1vngkd09tey6x">
            <Clock className="w-5 h-5" data-id="element-240" data-mp="k2w0x47qs5im" />
            EL PRECIO CIERRA EN: 23 hs : 59 min : 52 seg
          </div>

          <div className="grid md:grid-cols-1 gap-6 mb-8 max-w-md mx-auto" data-id="element-241" data-mp="y2ni1dtk220u">
            <div className="p-6 border border-lav-100 rounded-xl bg-lav-50" data-id="element-242" data-mp="u11zpcy94vj9">
              <h4 className="font-bold text-ink mb-2" data-id="element-243" data-mp="u36ckke4p4vo">
                MEAL PREP FITNESS LISTO
              </h4>
              <p className="text-sm text-slate-400 mb-4" data-id="element-244" data-mp="131hzabbvjiiu">
                6 Tomos + 5 Bonos · Organizá toda tu semana
              </p>
              <div className="flex items-baseline justify-center gap-2 mb-6" data-id="element-245" data-mp="1hpcsdstsnowg">
                <span className="text-slate-500 line-through text-sm" data-id="element-246" data-mp="1cqrtbwqa3b9l">
                  $49.000
                </span>
                <span className="text-3xl font-black text-ink" data-id="element-247" data-mp="1qs46y1hyv0sb">$19.990</span>
                <span className="text-sm text-slate-400" data-id="element-248" data-mp="1lshuhu9ypokk">ARS</span>
              </div>
              <Button className="w-full" variant="outline" onClick={() => {
              window.location.href = CHECKOUT_URL;
            }} data-id="element-249" data-mp="25drrhns307bp">
                🥗 QUIERO MI MEAL PREP FITNESS
              </Button>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-400" data-id="element-250" data-mp="20e5enfg60t3f">
            <span className="flex items-center" data-id="element-251" data-mp="1mnjttl75i92w">
              <Lock className="w-4 h-4 mr-1 text-slate-300" data-id="element-252" data-mp="1mlpbmen9kv2i" /> Pago 100% seguro
            </span>
            <span className="flex items-center" data-id="element-253" data-mp="1rfl26w177fnn">
              <Zap className="w-4 h-4 mr-1 text-lav-500" data-id="element-254" data-mp="1cpdw7fsdnp3u" /> Acceso inmediato
            </span>
            <span className="flex items-center" data-id="element-255" data-mp="1hnxijhavv2wq">
              <ShieldCheck className="w-4 h-4 mr-1 text-brand-500" data-id="element-256" data-mp="1hoqgbsrv6i2q" /> Garantía 7
              días
            </span>
            <span className="flex items-center" data-id="element-257" data-mp="13p7hxrouul3m">
              <CreditCard className="w-4 h-4 mr-1 text-lav-400" data-id="element-258" data-mp="18nsad4xv80hi" /> Mercado Pago
              | Tarjeta | Transferencia
            </span>
          </div>
        </Card>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="bg-slate-950 py-10 px-4 border-t border-lav-100" data-id="element-259" data-mp="39anwdtirws5k">
      <div className="max-w-4xl mx-auto text-center" data-id="element-260" data-mp="2vad6aspafhlg">
        <div className="inline-flex items-center gap-2 mb-6" data-id="element-261" data-mp="2vboagtmnard3">
          <span className="text-brand-600 font-bold tracking-widest uppercase" data-id="element-262" data-mp="308y7ovga07bh">
            🥗 PUNTO DIGITAL™
          </span>
        </div>

        <p className="text-slate-400 mb-4 max-w-2xl mx-auto" data-id="element-263" data-mp="3rzksm2xqduqf">
          Meal Prep Fitness Listo, para personas que quieren organizar sus
          comidas, ahorrar tiempo y mantener una alimentación fitness sin
          improvisar.
        </p>
        <p className="text-slate-500 mb-8 italic" data-id="element-264" data-mp="3j68wtn871kd7">
          Porque comer bien también se organiza.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-slate-400 mb-12" data-id="element-265" data-mp="apw6yg2a2stq">
          <a href="mailto:supportpuntodigital@gmail.com" className="hover:text-brand-600 transition-colors" data-id="element-266" data-mp="fka2qjkur1yx">
            supportpuntodigital@gmail.com
          </a>
          <a href="#" className="hover:text-brand-600 transition-colors" data-id="element-267" data-mp="ktb6apfz2v8f">
            www.puntodigital.store
          </a>
        </div>

        <div className="text-xs text-slate-600 space-y-2" data-id="element-268" data-mp="tn7jher5sxbp">
          <p data-id="element-269" data-mp="tpsizx3zj16a">© Punto Digital™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-270" data-mp="5yn71t160t19">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p data-id="element-271" data-mp="1ycprk7xag73">
            Material educativo de organización y alimentación. No reemplaza
            asesoramiento nutricional profesional.
          </p>
        </div>

        <div className="mt-12 pt-8 border-t border-lav-100" data-id="element-272" data-mp="aw6k4pm4mzrm">
          <p className="text-brand-500/70 font-medium italic" data-id="element-273" data-mp="1rbhl3sn19j2a">
            "Esta puede ser la última semana que improvisás tus comidas."
          </p>
          <p className="text-slate-500 text-sm mt-2" data-id="element-274" data-mp="1mblh3tec5rmq">
            "Organizá una vez y comé bien toda la semana."
          </p>
        </div>
      </div>
    </footer>;
}